import React = require("react");
import { Flex } from "../compositeComponents/FlexHelpers";
import { DateInputField } from "./DateInputField";
import { TimeInputField } from "./TimeInputField";
import { maybeAdjustEnd, maybeAdjustStart } from "./StartEndDateTimeFields";


type DateStartEndTimeFieldsProps = {
    start: Date,
    end: Date,
    onChanged: (start: Date, end: Date) => void
}
export function DateStartEndTimeFields(props: DateStartEndTimeFieldsProps): JSX.Element {

    function handleStartDateChange(value: Date) {
        const newStart = new Date(value.getFullYear(), value.getMonth(), value.getDate(), props.start.getHours(), props.start.getMinutes(), 0, 0);
        const { start, end } = maybeAdjustEnd(props.start, newStart, props.end);
        props.onChanged(start, end);
    }

    function handleEndDateChange(value: Date | null) {
        const newEnd = new Date(value.getFullYear(), value.getMonth(), value.getDate(), props.end.getHours(), props.end.getMinutes(), 0, 0);
        const { start, end } = maybeAdjustStart(props.start, props.end, newEnd);
        props.onChanged(start, end);
    }

    function handleStartTimeChange(value: Date) {
        const newStart = new Date(props.start.getFullYear(), props.start.getMonth(), props.start.getDate(), value.getHours(), value.getMinutes(), 0, 0);
        const { start, end } = maybeAdjustEnd(props.start, newStart, props.end);
        props.onChanged(start, end);
    }

    function handleEndTimeChange(value: Date | null) {
        const newEnd = new Date(props.end.getFullYear(), props.end.getMonth(), props.end.getDate(), value.getHours(), value.getMinutes(), 0, 0);
        const { start, end } = maybeAdjustStart(props.start, props.end, newEnd);
        props.onChanged(start, end);
    }


    return (
        // Make it fill two columns
        <>
            <Flex flexDirection="column" gap={16}>
                <Flex flexDirection="row">

                    <DateInputField
                        value={props.start}
                        onValueChange={handleStartDateChange}
                        label={!isSameDate(props.start, props.end) ? "Startdato" : "Dato"}
                        validator={() => { return { valid: true } }} />

                    {!isSameDate(props.start, props.end) &&
                        <DateInputField
                            value={props.end}
                            onValueChange={handleEndDateChange}
                            label={"Slutdato"}
                            validator={() => { return { valid: true } }} />
                    }

                </Flex>
                <Flex flexDirection="row">
                    
                    <TimeInputField
                        value={props.start}
                        label={"Start"}
                        onValueChange={handleStartTimeChange}
                        validator={() => { return { valid: true } }} />

                    <TimeInputField
                        value={props.end}
                        label={"Slut"}
                        onValueChange={handleEndTimeChange}
                        validator={() => { return { valid: true } }} />

                </Flex>
            </Flex>
        </>
    );
}


export function isSameDate(start: Date, end: Date) {
    const startDate = new Date(start.getFullYear(), start.getMonth(), start.getDate(), 0, 0, 0);
    const endDate = new Date(end.getFullYear(), end.getMonth(), end.getDate(), 0, 0, 0);
    return startDate.getTime() === endDate.getTime();
}